import styled from 'styled-components';
import { spacings } from '../../../../../tokens/spacings';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0%;
  min-width: 0;
`;

export const SettingsContainer = styled.div`
  padding-top: ${spacings.SMALL};
  display: flex;
  flex-direction: column;
  row-gap: ${spacings.SMALL};
`;
